import gsap from 'gsap'
import { reduceMotion } from '@js/animations/ReducedMotion'
import { createOnceOnEnter } from '@js/animations/scrollTriggerHelper'

const parseCounterValue = (el) => {
  const raw = el.getAttribute('data-counter-value') || el.textContent.trim()
  const suffix = el.getAttribute('data-counter-suffix') || ''
  const numeric = parseFloat(raw.replace(/[^\d.,-]/g, '').replace(',', '.'))

  return {
    value: Number.isFinite(numeric) ? numeric : 0,
    suffix,
    decimals: (raw.split(/[.,]/)[1] || '').length,
  }
}

export class Counter {
  constructor () {
    this._elements = document.querySelectorAll('[animation-counter]')

    if (!this._elements.length) {
      return
    }

    this.init()
  }

  init () {
    this._elements.forEach((el) => {
      const { value, suffix, decimals } = parseCounterValue(el)
      const counter = { val: 0 }

      if (reduceMotion) {
        el.textContent = value.toFixed(decimals) + suffix
        return
      }

      gsap.set(el, { autoAlpha: 0 })

      createOnceOnEnter({
        trigger: el,
        onEnter: () => {
          gsap.to(el, { autoAlpha: 1, duration: 0.3 })
          gsap.to(counter, {
            val: value,
            duration: 1.5,
            ease: 'power2.out',
            snap: decimals ? { val: Math.pow(10, -decimals) } : { val: 1 },
            onUpdate: () => {
              el.textContent = counter.val.toFixed(decimals) + suffix
            },
          })
        },
      })
    })
  }
}
